import React from 'react';
import { useInView } from 'react-intersection-observer';

const Manifesto: React.FC = () => {
  const { ref, inView } = useInView({ threshold: 0.12, triggerOnce: true });

  return (
    <section id="manifesto" className="bg-black py-36 px-10 text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_50%,rgba(201,169,110,0.05)_0%,transparent_70%)] pointer-events-none"></div>
      
      <div className={`max-w-[720px] mx-auto relative z-10 reveal ${inView ? 'visible' : ''}`} ref={ref}>
        <div className="font-serif text-[130px] text-mid leading-[0.4] mb-7">
          "
        </div>
        
        <p className="font-serif text-[clamp(22px,4vw,38px)] font-light italic text-silverLight leading-relaxed mb-11">
          Porter GERAK, c'est affirmer qui l'on est. Chaque pièce est une déclaration — silencieuse, puissante, indéniable.
        </p>
        
        <div className="w-16 h-px bg-gold mx-auto mb-7"></div>
        
        <span className="text-[9px] tracking-[4px] uppercase text-silver">
          GERAK — Fashion & Classic
        </span>
      </div>
    </section>
  );
};

export default Manifesto;